module.exports = __webpack_public_path__ + "static/media/4.433d8ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/tablet/4.png
// module id = 2499
// module chunks = 0